let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lfMoa")).then(() => parcelRequire('jJ1lg'));